import React from 'react';
import styles from './Advt.module.css';
import cn from 'classnames';
import { iconsSourcesSvg } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

const Advt = React.memo(({ className, advtInfo, getParams }) => {
  const {
    titleTextColor,
    phoneTextColor,
    // цветные круги
    circleTopBgColorStart,
    circleTopBgColorStop,
    circleTopColorDirection,
    circleBottomBgColorStart,
    circleBottomBgColorStop,
    circleBottomColorDirection,
    firstSmallCircleBgColor,
    secondSmallCircleBgColor,
    thirdSmallCircleBgColor,
  } = getParams;

  const colorChan = {
    sms: 'chan-sms',
    facebook: 'chan-facebook',
    vkgroup: 'chan-vkgroup', // сообщение вк
    telegram: 'chan-telegram',
    telegrambot: 'chan-telegrambot',
    viber: 'chan-viber',
    whatsapp: 'chan-whatsapp',
    livechat: 'chan-livechat',
    fbinstagram: 'chan-fbinstagram',
    vkcomments: 'chan-vkcomm', // повторение
    facebookcomments: 'chan-facebookcomments',
    smsMoney: 'chan-smsmoney',
    vk: 'chan-vkcomm', // комментарий вк
    vkcomm: 'chan-vkcomm', // комментарий вк
    ok: 'chan-ok',
    okgroup: 'chan-okgroup',
  };

  const colorBlockQR1 =
    advtInfo.qrTitle1 && colorChan[advtInfo.qrTitle1.toLowerCase()];
  const colorBlockQR2 =
    advtInfo.qrTitle2 && colorChan[advtInfo.qrTitle2.toLowerCase()];

  let phoneNumber = formatPhoneNumber(advtInfo.number, ' ');

  return (
    <div
      className={cn(className, styles['wrapper'], {
        [styles['wrapper--hidden']]:
          !advtInfo.qrCode1 &&
          !advtInfo.qrCode2 &&
          !advtInfo.label &&
          !advtInfo.socials &&
          !advtInfo.number,
      })}>
      <div className={styles['container']}>
        {(advtInfo.qrCode1 || advtInfo.qrCode2) && (
          <div className={styles['qrWrapper']}>
            {advtInfo.qrCode1 && (
              <div className={styles['qrBlock']}>
                {advtInfo.qrTitle1 && (
                  <span
                    className={`${styles['qrTitle']} ${styles[colorBlockQR1]}`}>
                    {advtInfo.qrTitle1}
                  </span>
                )}
                <div className={styles['left']}>
                  <img src={advtInfo.qrCode1} alt="qrCode" />
                </div>
              </div>
            )}
            {advtInfo.qrCode2 && (
              <div className={styles['qrBlock']}>
                {advtInfo.qrTitle2 && (
                  <span
                    className={`${styles['qrTitle']} ${styles[colorBlockQR2]}`}>
                    {advtInfo.qrTitle2}
                  </span>
                )}

                <div className={styles['left']}>
                  <img src={advtInfo.qrCode2} alt="qrCode" />
                </div>
              </div>
            )}
          </div>
        )}

        <div className={styles['right']}>
          <div className={styles['title']} style={{ color: titleTextColor }}>
            {advtInfo.label}
          </div>
          <div className={styles['desc']}>
            {advtInfo.socials &&
              advtInfo.socials.map((item) => (
                <div key={item} className={styles['icon']}>
                  {iconsSourcesSvg[item]}
                </div>
              ))}
            <div className={styles['number']} style={{ color: phoneTextColor }}>
              {phoneNumber}
            </div>
          </div>
        </div>
        <span
          className={styles['buble1']}
          style={{
            backgroundImage: `linear-gradient(${circleTopColorDirection}deg, ${circleTopBgColorStart}, ${circleTopBgColorStop})`,
          }}></span>
        <span
          className={styles['buble2']}
          style={{
            backgroundImage: `linear-gradient(${circleBottomColorDirection}deg, ${circleBottomBgColorStart}, ${circleBottomBgColorStop})`,
          }}></span>
        <span
          className={styles['buble3']}
          style={{ background: firstSmallCircleBgColor }}></span>
        <span
          className={styles['buble4']}
          style={{ background: secondSmallCircleBgColor }}></span>
        <span
          className={styles['buble5']}
          style={{ background: thirdSmallCircleBgColor }}></span>
      </div>
    </div>
  );
});

export default Advt;
